import i18n from '@gik/i18n';
import coreTranslationKeys from '@gik/i18n/en/core';
import { Button } from '@gik/ui/Button';
import { SvgIcon } from '@gik/ui/SvgIcon/SvgIcon';
import CloseIcon from '@heroicons/react/solid/XCircleIcon';
import React from 'react';

type DisableSuggestionsButtonProps = {
  className: string;
  onClick(): void;
};

export function DisableSuggestionsButton({ className, onClick }: DisableSuggestionsButtonProps) {
  return (
    <Button
      className={className}
      variant={'secondary-outline'}
      onClick={() => onClick()}
      append={<SvgIcon Icon={CloseIcon} />}
    >
      {i18n.t(coreTranslationKeys.core.disable).toString()}
    </Button>
  );
}
